import React from 'react';
import { Card, CardHeader, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import SafeIcon from '../../common/SafeIcon';
import { ScoreGauge, ActionItem } from '../../components/dashboards/DashboardWidgets';
import { masterMetrics } from '../../data/dashboardMasterLogic';
import { useNavigate } from 'react-router-dom';

export const CustomerDashboard = () => {
  const navigate = useNavigate();
  
  return (
    <div className="space-y-8 pb-20">
      <div className="flex justify-between items-end">
        <div>
          <h1 className="text-2xl font-black text-slate-900 uppercase tracking-tight">Customer Dashboard</h1>
          <p className="text-slate-500 mt-1 uppercase text-[10px] font-bold tracking-widest italic">Admin Overview: TechCorp AS</p>
        </div>
        <div className="flex gap-2">
          <Button variant="secondary" icon={<SafeIcon name="Download" />} onClick={() => navigate('/dashboard/reports')}>Rapport</Button>
          <Button variant="primary" icon={<SafeIcon name="Zap" />} onClick={() => navigate('/dashboard/orchestrator')}>AI Orchestrator</Button>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        <ScoreGauge title="WE Score" value={masterMetrics.weScore} color="#6366f1" />
        <ScoreGauge title="Org Health" value={masterMetrics.orgHealth} color="#06b6d4" />
        <ScoreGauge title="Conflict Risk" value={masterMetrics.conflictRisk} color="#f97316" />
        <ScoreGauge title="Stress Index" value={masterMetrics.stressIndex} color="#f43f5e" />
        <ScoreGauge title="Psych Safety" value={masterMetrics.psychSafety} color="#10b981" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-6">
          <Card className="border-l-4 border-l-rose-500">
            <CardHeader title="Top 3 Risikoområder" icon={<SafeIcon name="AlertTriangle" className="text-rose-500" />} />
            <CardContent className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {[
                { area: "Høyt stress", loc: "Utvikling", score: "82%" },
                { area: "Lav trygghet", loc: "Salg", score: "35%" },
                { area: "Kommunikasjon", loc: "Ledelse", score: "45%" }
              ].map((r, i) => (
                <div key={i} className="p-4 bg-rose-50 rounded-2xl border border-rose-100">
                  <p className="text-[10px] font-black text-rose-600 uppercase mb-1">{r.area}</p>
                  <p className="text-sm font-bold text-slate-800">{r.loc}</p>
                  <p className="text-xs font-black text-rose-500 mt-2">{r.score}</p>
                </div>
              ))}
            </CardContent>
          </Card>

          <Card>
            <CardHeader title="Anbefalte Tiltak" subtitle="Neste steg for organisasjonen" />
            <CardContent className="space-y-4">
              <ActionItem title="Book Oppfølgingsworkshop" desc="Fokus: Psykologisk trygghet i Salgsteamet" icon="Users" onClick={() => navigate('/dashboard/workshops')} />
              <ActionItem title="Lederstøtte: Utvikling" desc="Gjennomfør 1-til-1 med Sarah Chen" icon="Award" onClick={() => navigate('/dashboard/leader-actions')} />
              <ActionItem title="Ressurs-gjennomgang" desc="Vurder arbeidsbelastning i Q3" icon="Layers" onClick={() => navigate('/dashboard/90-day-plan')} />
            </CardContent>
          </Card>
        </div>

        <div className="space-y-6">
          <Card className="bg-slate-900 border-none text-white overflow-hidden">
            <CardHeader title="Quick Actions" />
            <CardContent className="grid grid-cols-1 gap-3">
              <Button variant="secondary" className="w-full justify-start bg-white/5 border-white/10 text-white" icon={<SafeIcon name="Target" />} onClick={() => navigate('/dashboard/90-day-plan')}>90 Day Plan</Button>
              <Button variant="secondary" className="w-full justify-start bg-white/5 border-white/10 text-white" icon={<SafeIcon name="Calendar" />} onClick={() => navigate('/dashboard/agenda-generator')}>Workshop Agenda</Button>
              <Button variant="secondary" className="w-full justify-start bg-white/5 border-white/10 text-white" icon={<SafeIcon name="FileText" />} onClick={() => navigate('/dashboard/board-presentation')}>Board Summary</Button>
            </CardContent>
          </Card>
          <div className="p-8 bg-indigo-600 rounded-[40px] text-white shadow-xl shadow-indigo-100">
             <SafeIcon name="Map" className="text-4xl text-indigo-200 mb-4" />
             <h4 className="text-xl font-black uppercase tracking-tighter">Org Heatmap</h4>
             <p className="text-xs text-indigo-100 mt-2 mb-6">Se den visuelle fordelingen av risiko i hele organisasjonstreet.</p>
             <Button variant="secondary" className="w-full bg-white text-indigo-600 border-none" onClick={() => navigate('/dashboard/heatmap')}>Åpne Heatmap</Button>
          </div>
        </div>
      </div>
    </div>
  );
};